<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'ProjProcessStatusRadio',
})
</script>
<template>
  <Radio.Group v-bind="$attrs" :options="PROJ_PROGRESS_STATUS_OPTIONS" />
</template>

<script lang="ts" setup name="ProjProcessStatusRadio">
import { PROJ_PROGRESS_STATUS_OPTIONS } from '@/constant/biz'
import { Radio } from 'ant-design-vue'
</script>
